import {UserPermissionEnum} from "../../../../utils/types/user";

export const syncQuicksightDashboardsReportingPermission = (
  hasDashboardAccess: boolean,
  activePermissions: ReadonlyArray<UserPermissionEnum>,
): ReadonlyArray<UserPermissionEnum> => {
  const hasReportingPermission = activePermissions.includes(
    UserPermissionEnum.QUICKSIGHT_DASHBOARDS,
  );

  if (hasDashboardAccess && !hasReportingPermission) {
    return [...activePermissions, UserPermissionEnum.QUICKSIGHT_DASHBOARDS];
  }

  if (!hasDashboardAccess && hasReportingPermission) {
    return activePermissions.filter(
      permission => permission !== UserPermissionEnum.QUICKSIGHT_DASHBOARDS,
    );
  }

  return activePermissions;
};
